import { AnimatedPageHeader } from '@components/index'
import { SearchInput } from '@components/search/SearchInput'
import { PartnersTable, PromotePartnerModal } from '@features/referral/components'
import { usePartners } from '@services/referral'
import { useQueryClient } from '@tanstack/react-query'
import { RefreshCw, UserPlus, Users } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

export function Partners() {
  const { t } = useTranslation('admin')
  const queryClient = useQueryClient()
  const [promoteModalOpen, setPromoteModalOpen] = useState(false)

  const { data: partnersData, isFetching } = usePartners()

  const handleRefresh = () =>
    queryClient.invalidateQueries({ queryKey: ['partners'] })

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <AnimatedPageHeader
          title={t('referrals.partners.title')}
          className="mb-0"
        />
        <div className="flex gap-2">
          <Button
            variant="ghostDark"
            onClick={handleRefresh}
            disabled={isFetching}
          >
            <RefreshCw className="h-4 w-4" />
            {t('common.refresh')}
          </Button>
          <Button onClick={() => setPromoteModalOpen(true)}>
            <UserPlus className="h-4 w-4" />
            {t('referrals.promote.title')}
          </Button>
        </div>
      </div>

      <Card className="flex max-w-xs items-center gap-4 p-5">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Users className="h-6 w-6" />
        </span>
        <div>
          <div className="font-display text-3xl font-bold leading-none text-ink">
            {partnersData?.count ?? 0}
          </div>
          <div className="mt-1 text-sm text-muted-foreground">
            {t('referrals.partners.totalPartners')}
          </div>
        </div>
      </Card>

      <div className="max-w-md">
        <SearchInput />
      </div>

      <PartnersTable />

      <PromotePartnerModal
        open={promoteModalOpen}
        onClose={() => setPromoteModalOpen(false)}
        onSuccess={handleRefresh}
      />
    </div>
  )
}
